import VueRouter, { Location } from 'vue-router'
import { uid, cookies, isMmz } from './cookie'
import qs from 'query-string'
import router from '@app/app-routing'

const vRoutes = [
  {
    path: '/home',
    name: 'home'
  },
  {
    path: '/consultantList',
    name: 'consultantList'
  },
  {
    path: '/indexPage',
    name: 'indexPage'
  },
  {
    path: '/secKill',
    name: 'secKill'
  },
  {
    path: '/product',
    name: 'products'
  },
  {
    path: '/product/:spuId',
    name: 'product-detail'
  },
  {
    path: '/product/:spuId/confirm',
    name: 'product-confirm'
  },
  {
    path: '/order/pay-success',
    name: 'pay-success'
  },
  {
    path: '/order/pay-fail',
    name: 'pay-fail'
  },
  {
    path: '/order/payment/:orderId',
    name: 'payment'
  },
  {
    path: '/order/:orderId/refund',
    name: 'order-refund'
  },
  {
    path: '/order/:orderCode',
    name: 'order-detail'
  },
  {
    path: '/order/group/:groupId',
    name: 'order-group'
  },
  {
    path: '/order/:orderCode/comment/success',
    name: 'comment-success'
  },
  {
    path: '/order/:orderCode/comment/share',
    name: 'comment-share'
  },
  {
    path: '/order/:orderCode/comment/add',
    name: 'comment-add'
  },
  // 评价列表  订单商品评价
  {
    path: '/product/:spuId/comments',
    name: 'comments'
  },
  {
    path: '/user/:uid/comment/add',
    name: 'comment-user-add'
  },
  // 评价列表 育儿顾问 认证育儿师
  {
    path: '/comments/:workerCode',
    name: 'comment-list'
  },
  {
    path: '/meaningLessComments/:id',
    name: 'meaningLessComments'
  },
  /**新的评价 */
  {
    path: '/evaluate',
    name: 'evaluate'
  },
  {
    path: '/workers/:serviceType?',
    name: 'worker'
  },
  {
    path: '/date',
    name: 'date'
  },
  {
    path: '/user/order',
    name: 'order-list'
  },
  {
    path: '/user/:uid/work',
    name: 'worker-date'
  },
  {
    path: '/user/:uid',
    name: 'user'
  },
  {
    path: '/user',
    name: 'user-no'
  },
  {
    path: '/user/:uid/service',
    name: 'service'
  },
  {
    path: '/user/:uid/licence',
    name: 'service-licence'
  },
  {
    path: '/user/:uid/evaluate',
    name: 'userEvaluate'
  },
  {
    path: '/user/:uid/experience',
    name: 'experience'
  },
  {
    path: '/entering/step:stepNo',
    name: 'entering'
  },
  {
    path: '/yuesao/step:stepNo',
    name: 'entering-yuesao'
  },
  {
    path: '/store/workers',
    name: 'store-worker-list'
  },
  {
    path: '/collect',
    name: 'collect'
  },
  {
    path: '/collect-fill',
    name: 'collect-fill'
  },
  // 所有品类列表
  {
    path: '/categorylist',
    name: 'categorylist'
  },
  {
    path: '/category',
    name: 'category'
  },
  // 对应tab下的商品列表
  {
    path: '/category/t/:searchId',
    name: 'category-detail'
  },
  // 对应分类下商品列表
  {
    path: '/category/p/:cateId',
    name: 'category-product'
  },
  // 分享赚页面
  {
    path: '/activity/share',
    name: 'activity-share'
  },
  // 新分享赚页面
  {
    path: '/activity/newShare',
    name: 'activity-newShare'
  },
  // 分享赚 - 我的清单
  {
    path: '/activity/mysharelist',
    name: 'activity-mysharelist'
  },
  // 育儿服务拼团列表
  {
    path: '/groupBuy/groupList',
    name: 'group-buy'
  },
  // 拼团商详
  {
    path: '/groupBuy/groupInfo/:spuId',
    name: 'group-info'
  },
  // 正在拼团中列表
  {
    path: '/groupBuy/moreGroups',
    name: 'more-groups'
  },
  // 服务日志列表
  {
    path: '/service-log/list/:origin/:type/:orderId',
    name: 'log-list'
  },
  // 服务日志订单列表
  {
    path: '/service-order/list',
    name: 'service-order'
  },
  // 日志编辑
  {
    path: '/service-log/edit/:id',
    name: 'log-edit'
  },
  // 日志查看
  {
    path: '/service-log/view/:origin/:id',
    name: 'log-view'
  },
  // 产后恢复
  {
    path: '/recovery',
    name: 'recovery'
  },
  {
    path: '/recovery-detail',
    name: 'recovery-detail'
  },
  {
    path: '/recovery-licence',
    name: 'recovery-licence'
  },
  {
    path: '/total-comment',
    name: 'total-comment'
  },
  {
    path: '/articles',
    name: 'articles'
  },
  // 服务优惠--拼团秒杀
  {
    path: '/groupandseckill',
    name: 'groupandseckill'
  },
  // 话题
  {
    path: '/pregnancytopic',
    name: 'pregnancytopic'
  },
  {
    path: '/map',
    name: 'map'
  },
  {
    path: '/confirmYuesao',
    name: 'confirmYuesao'
  }
]

class RouterClass extends VueRouter {}

const vRouter = new RouterClass({
  base: '/v',
  mode: 'history',
  routes: vRoutes
})

export function toV(loc: Location, jump = true) {
  const { href } = vRouter.resolve(loc)
  if (jump) {
    location.href = `//life.cekid.com${href}`
  } else {
    return `//life.cekid.com${href}`
  }
}

export function toCzj(url = 'https://m.czj100.com/port/cash/?cmd=share&sharetype=0', jump = true) {
  const suffix = uid ? `&uid=${uid}&skey=${cookies.get('skey') || ''}` : ''
  const miniprogramid = cookies.get('miniprogramid') || ''
  if (jump) {
    location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(url)}${suffix}&miniprogramid=${miniprogramid}`
  } else {
    return `//app.czj100.com/webridge.html?url=${encodeURIComponent(url)}${suffix}&miniprogramid=${miniprogramid}`
  }
}

function transformCzjUrl(url: string) {
  const suffix = uid ? `&uid=${uid}&skey=${cookies.get('skey') || ''}` : ''
  const newUrl = `${url}&cmd=share&sharetype=1`
  return `//app.czj100.com/webridge.html?kwtarget=blank&url=${encodeURIComponent(newUrl)}${suffix}`
}

interface ToDetailParams {
  spuType?: number //201:摄影  401:月嫂 402:育儿  601:景区  其他默认跳成长加默认详情
  businessType?: 20 | 21 //20 czj 21 yuer
  spuId?: string
  businessId?: string
  toYuesao?: boolean
  uid?: string
  toShop?: boolean //true跳转到店铺  false到商详
  isSpot?: boolean //ture代表景区
  module?: number //订单记录转化模块字段 模块:1天天特卖、2内容种草、3搜索、4icon品类页、5瀑布流商品(APP) 6 超值特价
}

export function searchToWhereUrl(param: ToDetailParams) {
  const params = location.search.replace(/^\?/, '').split('&')
  let hserecomkey
  params.forEach(p => {
    const res = p.split('=')
    if (res[0] === 'hserecomkey') {
      hserecomkey = res[1]
    }
  })
  const { toShop, isSpot, businessType, businessId, spuType, spuId = '', toYuesao, uid = '', module = 0 } = param
  const isMMz = isMmz()
  const mmzStr = isMMz ? `&hzwMmz=1` : ''
  const moduleStr = module ? `&module=${module}` : ''
  if (toShop) {
    if (isSpot) {
      return `//life.cekid.com/v2/ticket/detail/${businessId}?kwtarget=blank&refresh=no${hserecomkey ? `&hserecomkey=${hserecomkey}` : ''}` + moduleStr + mmzStr
      // return transformCzjUrl(`//m.czj100.com/details/ticket/${businessId}?spuId=${businessId}&hserecomkey=${hserecomkey}`)
    } else {
      return `//life.cekid.com/h5/shop?businessId=${businessId}&kwtarget=blank&refresh=no`
    }
  } else if (toYuesao) {
    const { href } = vRouter.resolve({ name: 'user', params: { uid }, query: { refresh: 'no', kwtarget: 'blank' } })
    return `//life.cekid.com${href}`
  } else {
    if (spuType === 601 || spuType === 602) {
      //景区的spuId是businessId
      return `//life.cekid.com/v2/ticket/detail/${businessId}?kwtarget=blank&refresh=no&skuId=${spuId}${hserecomkey ? `&hserecomkey=${hserecomkey}` : ''}` + moduleStr + mmzStr
      // return transformCzjUrl(`//m.czj100.com/details/ticket/${businessId}?spuId=${businessId}&skuId=${spuId}&hserecomkey=${hserecomkey}`)
    } else {
      //统一详情
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const query = module ? { refresh: 'no', businessId, kwtarget: 'blank', hserecomkey, module: module.toString() } : { refresh: 'no', businessId, kwtarget: 'blank', hserecomkey }
      const { href } = vRouter.resolve({ name: 'product-detail', params: { spuId }, query })
      let link = `//life.cekid.com${href}`
      if(isMMz){
        link = link.indexOf('?') > -1 ? link + `&hzwMmz=1` : link + `?hzwMmz=1`
      }
      return link
    }
  }
}

interface DetailParams {
  spuType?: number //201:摄影  401:月嫂 402:育儿  601:景区  其他默认跳成长加默认详情
  businessId?: string
  spuId?: string
  skuId?: string
  ruleId?: string
  ruleType?: string
  isSpot?: boolean //ture代表景区
  module?: number //订单记录转化模块字段 模块:1天天特卖、2内容种草、3搜索、4icon品类页、5瀑布流商品(APP) 6 超值特价
}

export function gotoDetail(param: DetailParams) {
  const params = location.search.replace(/^\?/, '').split('&')
  let hserecomkey
  params.forEach(p => {
    const res = p.split('=')
    if (res[0] === 'hserecomkey') {
      hserecomkey = res[1]
    }
  })

  const { businessId, spuType, spuId = '', skuId = '', ruleId = '', ruleType = '', module = 0 } = param
  const moduleStr = module ? `&module=${module}` : ''
  if (spuType == 601 || spuType == 602) {
    //景区的spuId是businessId
    location.href = `//life.cekid.com/v2/ticket/detail/${businessId}?kwtarget=blank&refresh=no&skuId=${spuId}${hserecomkey ? `&hserecomkey=${hserecomkey}` : ''}` + moduleStr
    // location.href = transformCzjUrl(`//m.czj100.com/details/ticket/${businessId}?spuId=${businessId}&skuId=${spuId}&ruleType=${ruleType}&ruleId=${ruleId}`)
  } else {
    //统一商详
    //ruleType 3秒杀 4拼团
    if (ruleType == '4') {
      location.href = `//life.cekid.com/v/groupBuy/groupInfo/${spuId}?skuId=${skuId}&ruleId=${ruleId}&ruleType=${ruleType}${hserecomkey ? `&hserecomkey=${hserecomkey}` : ''}&refresh=no` + moduleStr
    } else if (ruleType == '3') {
      location.href = `//life.cekid.com/v/product/${spuId}?skuId=${skuId}&ruleId=${ruleId}&ruleType=${ruleType}${hserecomkey ? `&hserecomkey=${hserecomkey}` : ''}&refresh=no` + moduleStr
    } else {
      const query = module ? { refresh: 'no', businessId, kwtarget: 'blank', hserecomkey, module: module.toString() } : { refresh: 'no', businessId, kwtarget: 'blank', hserecomkey }
      const { href } = vRouter.resolve({ name: 'product-detail', params: { spuId }, query })
      location.href = `//life.cekid.com${href}`
    }
  }
}

/**
 * 根据服务端取得的链接拼接新的商品地址详情
 * @param linkUrl
 */
export function productLinkUrl(linkUrl: string, module: number) {
  const urlObj = qs.parseUrl(location.href)
  const hserecomkey = urlObj.query.hserecomkey || ''
  const moduleStr = module ? `&module=${module}` : ''
  const isMMz = isMmz()
  const mmzStr = isMMz ? `&hzwMmz=1` : ''
  return `${linkUrl}${linkUrl.indexOf('?') > -1 ? '&' : '?'}hserecomkey=${hserecomkey + moduleStr + mmzStr}${linkUrl.indexOf('refresh=no') > -1 ? '' : '&refresh=no'}${linkUrl.indexOf('kwtarget=blank') > -1 ? '' : '&kwtarget=blank'}`
}
